import React, { useState, useEffect, useRef } from "react";
import NavBars from '../Sidebar/Sidebar';
import './protected.css';
import moment from "moment";
import { Calendar as Cal, momentLocalizer } from 'react-big-calendar';
import "react-big-calendar/lib/css/react-big-calendar.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { db } from "../../firebase";
import { UserAuth, fetchAdminPassword } from "../../authContext";
import { collection, query, where, getDocs, getDoc, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { FaPlus, FaTrash } from 'react-icons/fa';

const Calendar = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const { user } = UserAuth();
    const localizer = momentLocalizer(moment);
    const [eventsData, setEventsData] = useState([]);
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState('');
    const [eventName, setEventName] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [allDay, setAllDay] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [editingEvent, setEditingEvent] = useState(null);
    const formRef = useRef(null);
    const calculateEndDate = (startDate, duration) => {
        const end = startDate;
        
        end.setDate(startDate.getDate() + Number(duration) -1);
        return end;
    };
    
    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                // Simulate a delay to fetch user info
                const storedUser = JSON.parse(localStorage.getItem('user'));
                const storedIsAdmin = localStorage.getItem('isAdmin') === 'true';
  
                if (storedUser && storedUser.email === user?.email) {
                    setIsAdmin(storedIsAdmin);
                } else {
                    setIsAdmin(false);
                }
            } catch (error) {
                console.error("Failed to fetch admin status:", error);
                setIsAdmin(false);
            } 
        };
  
        if (user) {
            checkAdminStatus();
        } 
    }, [user]);
    
    const fetchEvents = async () => {
        if (user) {
            try {
                // Fetch the user's projects
                const q = query(collection(db, 'users'), where('email', '==', user.email));
                const querySnapshot = await getDocs(q);
                const projectRefs = [];
                let events = [];
                if (!querySnapshot.empty) {
                    const userData = querySnapshot.docs[0].data();
                    // Create an array of promises to fetch project documents
const projectPromises = userData.projects.map(async (projectRef) => {
    try {
        // Fetch project document
        const projectDoc = await getDoc(projectRef);
        const project = projectDoc.data();
        console.log(project.isActive);
        // Push project reference and event to the respective arrays
        projectRefs.push(projectRef);
        if (project.active) {
            events.push({
                start: project.startDate ? project.startDate.toDate() : new Date(), // Default to current date if startDate is undefined
                end: calculateEndDate(
                    project.startDate.toDate(), // Ensure startDate is used for calculation
                    project.duration
                ),
                title: project.name,
                allDay: true,
            });
        }
    } catch (error) {
        console.error("Error fetching project:", error);
    }
});

// Wait for all promises to resolve
await Promise.all(projectPromises);

// Proceed with the populated projectRefs and events arrays

                    projectRefs.push(doc(db, 'Administrator', 'b7vezvAiyvN3qly0F25b'));
                }
                console.log(projectRefs)
                // Fetch events with a valid projectRef
                
                if (projectRefs.length > 0) {
                    const eventsQuery = query(collection(db, 'calendar-events'), where('projectRef', 'in', projectRefs));
                    const eventsSnapshot = await getDocs(eventsQuery);
                    eventsSnapshot.forEach(doc => {
                        const event = doc.data();
                        events.push({
                            id: doc.id,
                            start: event.start ? event.start.toDate() : new Date(),  // Provide a default value if undefined
                            end: event.end ? event.end.toDate() : new Date(),        // Provide a default value if undefined
                            title: event.title, 
                            allDay: event.allDay,
                        });
                    });
                }
    
                // Query for events where projectRef is either null or not present
            const commonEventsQuery = query(collection(db, 'calendar-events'), where('projectRef', '==', null));
            const commonEventsSnapshot = await getDocs(commonEventsQuery);

            commonEventsSnapshot.forEach(doc => {
                const event = doc.data();
                events.push({
                    id: doc.id,
                    start: event.start.toDate(),
                    end: event.end.toDate(),
                    title: event.title,
                    allDay: event.allDay,
                });
            });
                // Update state with the fetched events
                setEventsData(events);
            } catch (error) {
                console.error('Error fetching events:', error);
            }
        }
    };
    useEffect(() => {
        const fetchProjects = async (userEmail) => {
            if (user) {
                const q = query(collection(db, 'users'), where('email', '==', userEmail));
                const querySnapshot = await getDocs(q);
                if (!querySnapshot.empty) {
                    const userData = querySnapshot.docs[0].data();
                    const projectRefs = userData.projects;  // Assuming 'projects' is an array of project references.
                    const projectPromises = projectRefs.map(async projectRef => {
                        const projectDoc = await getDoc(projectRef);
                        return projectDoc.exists() ? { id: projectDoc.id, ref: projectRef, ...projectDoc.data() } : null;
                    });
                    const projectResults = await Promise.all(projectPromises);
                    setProjects(projectResults.filter(project => project !== null));
                    return projectRefs;  // Return project references for fetching events.
                }
            }
            return [];
        };
    
        const loadProjectsAndEvents = async () => {
            const projectRefs = await fetchProjects(user.email); // Fetch projects and get references
            await fetchEvents(projectRefs); // Fetch events using the project references
        };
    
        if (user) {
            loadProjectsAndEvents();
        }
    }, [user]);
    

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (formRef.current && !formRef.current.contains(event.target)) {
                setShowForm(false);
                resetForm();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const promptForPassword = async () => {
        const password = prompt('Enter admin password:');
        if (password !== await fetchAdminPassword() ) {
            alert('Invalid password.');
            return false;
        }
        return true;
    };

    const handleProjectChange = (projectName) => {
        setSelectedProject(projectName);
    
        const selected = projects.find(project => project.name === projectName);
        if (selected) {
            setStartDate(selected.startDate ? selected.startDate.toDate() : new Date());  // Safeguard toDate()
            setEndDate(selected.endDate ? selected.endDate.toDate() : new Date());        // Safeguard toDate()
        }
    };
    

    const handleAddEvent = async () => {

        if (selectedProject && eventName) {
            const project = projects.find(project => project.name === selectedProject);
            const projectRef = project ? project.ref : doc(db, 'Administrator', 'b7vezvAiyvN3qly0F25b');

            const newEvent = {
                start: startDate,
                end: endDate,
                title: `${eventName} (${selectedProject})`,
                allDay,
                projectRef,
            };

            try {
                const docRef = await addDoc(collection(db, 'calendar-events'), newEvent);
                setEventsData([...eventsData, { ...newEvent, id: docRef.id }]);
                alert('Event added successfully!');
                resetForm();
                setShowForm(false);
            } catch (error) {
                console.error('Error adding event:', error);
                alert('Failed to add event.');
            }
        } else {
            alert("Please select a project and enter an event name.");
        }
    };

    const handleEditEvent = async () => {
        if (selectedProject === 'Lab Event') {
            if (!isAdmin) return;
        }

        if (editingEvent) {
            const updatedEvent = {
                start: startDate,
                end: endDate,
                title: `${eventName} (${selectedProject})`,
                allDay,
            };

            try {
                await updateDoc(doc(db, 'calendar-events', editingEvent.id), updatedEvent);
                const updatedEvents = eventsData.map(event =>
                    event.id === editingEvent.id ? { ...updatedEvent, id: event.id } : event
                );
                setEventsData(updatedEvents);
                alert('Event updated successfully!');
                resetForm();
                setShowForm(false);
            } catch (error) {
                console.error('Error updating event:', error);
                alert('Failed to update event.');
            }
        } else {
            alert("Please select an event to edit.");
        }
    };

    const handleDeleteEvent = async () => {
        if (selectedProject === 'Lab Event' && !isAdmin) {
            return;
        }

        if (editingEvent) {
            const confirmDelete = window.confirm("Are you sure you want to delete this event?");
            if (confirmDelete) {
                try {
                    await deleteDoc(doc(db, 'calendar-events', editingEvent.id));
                    setEventsData(eventsData.filter(event => event.id !== editingEvent.id));
                    alert('Event deleted successfully!');
                    resetForm();
                    setShowForm(false);
                } catch (error) {
                    console.error('Error deleting event:', error);
                    alert('Failed to delete event.');
                }
            }
        } else {
            alert("Please select an event to delete.");
        }
    };

    const handleSelect = ({ start, end }) => {
        setStartDate(start);
        setEndDate(end);
    };

    const handleEventClick = (event) => {    
            try { 
                const project = event.title.split(' (')[1].split(')')[0];
                setEditingEvent(event);
                if(project === "Lab Event" && !isAdmin){
                    alert("Only admins may edit this event");
                    return;
                }
                setSelectedProject(project);
                setEventName(event.title.split(' (')[0]);
                setStartDate(event.start);
                setEndDate(event.end);
                setAllDay(event.allDay);
                setShowForm(true);
            } catch (error) {
                alert("This is a project not an event, \nKindly contact the admin to change the times");
            }
    };

    const handleStartDateChange = (date) => {
        if (date && endDate && date > endDate) {
            setEndDate(date);
        }
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        if (date && startDate && date < startDate) {
            setStartDate(date);
        }
        setEndDate(date); // Add 1 day in milliseconds
    };

    const resetForm = () => {
        setSelectedProject('');
        setEventName('');
        setStartDate(new Date());
        setEndDate(new Date());
        setAllDay(false);
        setEditingEvent(null);
    };

    if (!user) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <div className='content'>
                <div className="grid-container">
                    {showForm && (
                        <div className="modal" ref={formRef}>
                            <select
                                value={selectedProject}
                                onChange={(e) => handleProjectChange(e.target.value)}
                                disabled={!!editingEvent}
                            >
                                <option value="">Select a Project</option>
                                {isAdmin&&<option value="Lab Event">Lab Event</option>}
                                {projects
                                    .filter((project) => project.active) // Filter only active projects
                                    .map((project) => (
                                        <option key={project.id} value={project.name}>
                                            {project.name}
                                        </option>
                                    ))
}
                            </select>
                            <input
                                type="text"
                                placeholder="Event Name"
                                value={eventName}
                                onChange={(e) => setEventName(e.target.value)}
                            />
                            <DatePicker
                                selected={startDate}
                                onChange={handleStartDateChange}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                showTimeSelect={!allDay}
                                dateFormat={allDay ? "MMMM d, yyyy" : "MMMM d, yyyy h:mm aa"}
                            />
                            <DatePicker
                                selected={endDate}
                                onChange={handleEndDateChange}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                showTimeSelect={!allDay}
                                dateFormat={allDay ? "MMMM d, yyyy" : "MMMM d, yyyy h:mm aa"}
                            />
                            <div>
                                <input
                                    type="checkbox"
                                    checked={allDay}
                                    onChange={() => setAllDay(!allDay)}
                                    className="cb-input"
                                />
                                <label className="cb-label">All Day Event</label>
                            </div>
                            <button className='modal-button' onClick={editingEvent ? handleEditEvent : handleAddEvent}>
                                {editingEvent ? 'Update' : 'Add'}
                            </button>
                            {editingEvent && (
                                <button onClick={handleDeleteEvent} className="modal-button delete">
                                    <FaTrash style={{ color: 'white' }} />
                                </button>
                            )}
                        </div>
                    )}
                    <Cal
                        views={["day", "agenda", "work_week", "month"]}
                        selectable
                        localizer={localizer}
                        defaultDate={new Date()}
                        defaultView="month"
                        events={eventsData}
                        style={{ height: "84vh", width: "100%" }}
                        onDoubleClickEvent={handleEventClick}
                        onSelectSlot={handleSelect}
                    /> 
                    <button
                        className="floating-button"
                        onClick={() => {
                            setShowForm(!showForm);
                            if (showForm) resetForm();
                        }}
                    >
                        <FaPlus style={{ color: 'white' }} />
                    </button>
                </div>
            </div>
            <NavBars />
        </div>
    );
};

export default Calendar;